import { render, staticRenderFns } from "./Study_card.vue?vue&type=template&id=5834b6d7"
import script from "./Study_card.vue?vue&type=script&lang=js"
export * from "./Study_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports